import { useState } from 'react';
import type { Contact, KpiCommitment } from '../../api/regulations';
import { Icon } from '../../components/Icon';
import { CommitmentsView, ContactsView } from '../../components/RegulationBlock';

/** Сколько строк показывать в карточке до нажатия «ещё»: у связей — в каждой группе отдельно. */
const VISIBLE_CONTACTS = 4;
const VISIBLE_COMMITMENTS = 3;

/**
 * Шапка кабинета: с чем к сотруднику обращаются, к кому обращается он и за что получает премию.
 * Коротко и сразу под карточкой человека; полностью — в «Регламенте» и «Оклад и KPI».
 */
export function CabinetBrief({
  contacts,
  commitments,
}: {
  contacts: Contact[];
  commitments: KpiCommitment[];
}) {
  const [allCommitments, setAllCommitments] = useState(false);
  if (!contacts.length && !commitments.length) return null;
  const shownCommitments = allCommitments ? commitments : commitments.slice(0, VISIBLE_COMMITMENTS);
  return (
    <section className="panel brief">
      {contacts.length ? (
        <section className="brief-card">
          <h3>
            Связи <span className="reg-count">{contacts.length}</span>
          </h3>
          <ContactsView contacts={contacts} limit={VISIBLE_CONTACTS} />
        </section>
      ) : null}
      {commitments.length ? (
        <section className="brief-card">
          <h3>
            За что премия <span className="reg-count">{commitments.length}</span>
          </h3>
          <CommitmentsView items={shownCommitments} />
          {commitments.length > shownCommitments.length ? (
            <button type="button" className="btn-secondary more-row" onClick={() => setAllCommitments(true)}>
              <Icon name="plus" size={14} />
              Ещё {commitments.length - shownCommitments.length}
            </button>
          ) : null}
        </section>
      ) : null}
    </section>
  );
}
